import { useQueryParams } from './useQueryParams';

export const useQueryParam = (param: string) => {
	const queryParam = useQueryParams().get(param);
	return queryParam || null;
};
